class PromotionalCountdown extends HTMLElement {
  /** @type {number | null} */
  #timer = null;

  /** @type {number | null} */
  #endTime = null;

  /** @type {number | null} */
  #lastAnnouncedMinute = null;

  connectedCallback() {
    const rawEndDate = (this.dataset.endDate || '').trim();
    const normalizedEndDate = rawEndDate.replace(
      /^(\d{4})-(\d{1,2})-(\d{1,2})(?=T)/,
      (_, year, month, day) => `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    );
    const parsedTime = Date.parse(normalizedEndDate);
    
    if (!Number.isFinite(parsedTime)) return;

    this.#endTime = parsedTime;
    this.hidden = false;
    this.#update();

    if (this.#endTime > Date.now()) {
      this.#timer = window.setInterval(() => this.#update(), 1000);
    }
  }

  disconnectedCallback() {
    this.#stop();
  }

  #update() {
    if (this.#endTime === null) return;

    const remaining = Math.max(0, this.#endTime - Date.now());

    if (remaining === 0) {
      this.#expire();
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.#setValue('[data-days]', days);
    this.#setValue('[data-hours]', hours);
    this.#setValue('[data-minutes]', minutes);
    this.#setValue('[data-seconds]', seconds);

    const liveText = this.querySelector('[data-live-text]');
    if (liveText && this.#lastAnnouncedMinute !== totalSeconds - seconds) {
      liveText.textContent = `${days} days, ${hours} hours, ${minutes} minutes remaining`;
      this.#lastAnnouncedMinute = totalSeconds - seconds;
    }
  }

  /**
   * @param {string} selector
   * @param {number} value
   */
  #setValue(selector, value) {
    const element = this.querySelector(selector);
    if (element) element.textContent = String(value).padStart(2, '0');
  }

  #expire() {
    this.#stop();

    if (this.dataset.hideAfterExpiry === 'true') {
      this.closest('.announcement-bar')?.setAttribute('hidden', '');
      return;
    }

    const time = this.querySelector('.campaign-countdown__time');
    const heading = this.querySelector('.campaign-countdown__heading');
    const expired = this.querySelector('[data-expired-text]');
    if (time instanceof HTMLElement) time.hidden = true;
    if (heading instanceof HTMLElement) heading.hidden = true;

    if (expired instanceof HTMLElement && this.dataset.expiredMessage) {
      expired.textContent = this.dataset.expiredMessage;
      expired.hidden = false;
    } else {
      this.hidden = true;
    }
  }

  #stop() {
    if (this.#timer !== null) {
      window.clearInterval(this.#timer);
      this.#timer = null;
    }
  }
}

if (!customElements.get('promotional-countdown')) {
  customElements.define('promotional-countdown', PromotionalCountdown);
}
